export default "__VITE_ASSET__BUpExytJ__"